module.exports = __webpack_public_path__ + "img/Beach-Volleyball.7d397c95.png";